import { render, staticRenderFns } from "./KeFuPage.vue?vue&type=template&id=653a5ebe&"
import script from "./KeFuPage.vue?vue&type=script&lang=js&"
export * from "./KeFuPage.vue?vue&type=script&lang=js&"
import style0 from "./KeFuPage.vue?vue&type=style&index=0&id=653a5ebe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports